// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1KOmk","title":"Logo_title__3kUJO","subtitle":"Logo_subtitle__njuKT","img":"Logo_img__1QOIG"};